enum Permissions {
    Alarms = "alarms",
    GlobalSearch = "globalSearch",
    InfoModule = "infomodul",
    Maintenance = "maintenance",
    Mobilbase = "mobilbase",
    SMSDoorOpener = "dooropener",
    Statistics = "statistics",
    UserManagement = "usermanagement",

    DigitalLicenses = "digitale-licenser",

    CustomerManagement = "customermanagement"
}

export default Permissions
